import React from 'react';
import useUser from './useUser';
import type { IUserState } from './useUser';

function withUserHOC(Component: any) {
    return function (props: any) {
        const WithUser: React.FC<React.PropsWithChildren<any>> = (props) => {
            const [user, userActions] = useUser();

            // React.useEffect(() => {
            //     // userActions.getStatus();
            // }, []);

            return <Component {...props} user={user} userActions={userActions}></Component>;
        };

        return <WithUser {...props} />;
    };
}

// export { withUserHOC, IUserState };
export { withUserHOC, IUserState };
export default withUserHOC;
